import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const testTypeLocaleModule: LocaleModule = {
  name: "testType",
  messages: { en: en, it: it },
};
